// src/pages/mypwd.ts —— 账号区「修改密码」（06 C-21 / S-86）：PUT /api/admin/my-password → {relogin:true}，后端吊销全部会话（含当前）
import { ApiError } from '../../../shared/src/api/client';
import { openForm } from '../domains/table';
import { str, type AdminCtx } from '../domains/types';
import type { FormDef } from './types';
import { localErr } from './ui';

const PWD_RE = /^(?=.*[A-Za-z])(?=.*\d).{8,64}$/; // 07 §3 / X-24：≥8 位且含字母与数字

export function myPwdForm(ctx: AdminCtx): FormDef {
  const t = ctx.t;
  const account = ctx.host.state.sh.me?.account ?? ctx.host.state.adminUser;
  // 字段键与标签取原型 L1100（old / nw / nw2；oldPwd / newPwd / newPwd2）
  return {
    title: `${str(t, 'myPwd')} · ${account}`,
    tip: str(t, 'myPwdTip'),
    fields: [
      { k: 'old', label: str(t, 'oldPwd'), type: 'password' },
      { k: 'nw', label: str(t, 'newPwd'), type: 'password' },
      { k: 'nw2', label: str(t, 'newPwd2'), type: 'password' },
    ],
    init: { old: '', nw: '', nw2: '' },
    validate: (v, d) => {
      const old = String(v['old'] ?? '');
      const nw = String(v['nw'] ?? '');
      if (nw !== String(v['nw2'] ?? '')) return str(d, 'errPwdMatch');
      return !PWD_RE.test(nw) || nw === old ? str(d, 'errPwdRule') : '';
    },
    submit: async (c, v) => {
      const route = 'PUT /api/admin/my-password';
      try {
        await c.gp.api.call(route, { body: { old: String(v['old'] ?? ''), new: String(v['nw'] ?? '') } });
      } catch (e) {
        // 06 C-21：旧密码错 → errOldPwd（与首登向导同口径）；后端规则拒绝 4220 → errPwdRule
        if (e instanceof ApiError && (e.code === 1001 || e.code === 4220)) throw localErr(route, str(c.t, e.code === 1001 ? 'errOldPwd' : 'errPwdRule'));
        throw e;
      }
      // relogin 是会话结束的唯一入口（换代、清 token、发 session:lost、复位 page / tab / me、toast），各域据 lost 复位自身切片
      c.gp.session.relogin('toastMyPwd', 'pwd_changed');
    },
  };
}

export function openMyPwd(ctx: AdminCtx): void {
  openForm(ctx, myPwdForm(ctx));
}
